import { render, staticRenderFns } from "./traterbankAdd.vue?vue&type=template&id=79289e5e&scoped=true&"
import script from "./traterbankAdd.vue?vue&type=script&lang=js&"
export * from "./traterbankAdd.vue?vue&type=script&lang=js&"
import style0 from "./traterbankAdd.vue?vue&type=style&index=0&id=79289e5e&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79289e5e",
  null
  
)

export default component.exports